// Portfolio store (Phase 5 leaf module) — localStorage-backed positions list.
export const Portfolio = (() => {
    const KEY = 'abPortfolioV1';
    let positions = load();
    function load() {
        try { const r = JSON.parse(localStorage.getItem(KEY)); if (Array.isArray(r)) return r; } catch (e) {}
        return [];
    }
    function save() { try { localStorage.setItem(KEY, JSON.stringify(positions)); } catch (e) {} }
    function all() { return positions.slice(); }
    function add(pos) {
        pos.id = pos.id || `${pos.ticker}-${pos.date}-${Date.now()}`;
        positions.push(pos); save(); return pos;
    }
    function remove(id) { positions = positions.filter(p => p.id !== id); save(); }
    function update(id, patch) { const p = positions.find(x => x.id === id); if (p) { Object.assign(p, patch); save(); } }
    return { all, add, remove, update, _save: save };
})();
